import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import api from '../services/api';

export const useCheckpointAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      refreshToken: null,
      isAuthenticated: false,
      tenantId: null,
      
      login: async (email, password) => {
        try {
          // Usamos a mesma rota de login
          const response = await api.post('/auth/login', { email, password });
          const { data } = response.data;
          
          set({
            user: data.user,
            token: data.access_token,
            refreshToken: data.refresh_token,
            isAuthenticated: true,
            tenantId: data.user.tenant_id,
          });
          
          return { success: true };
        } catch (error) {
          console.error('Login error:', error);
          return {
            success: false,
            error: error.response?.data?.message || error.message || 'Erro ao fazer login',
          };
        }
      },
      
      logout: () => {
        set({
          user: null,
          token: null,
          refreshToken: null,
          isAuthenticated: false,
          tenantId: null,
        });
      },
      
      refreshAccessToken: async () => {
        const { refreshToken } = get();
        
        if (!refreshToken) {
          get().logout();
          return false;
        }
        
        try {
          const response = await api.post('/auth/refresh', {
            refresh_token: refreshToken,
          });
          
          const { data } = response.data;
          
          set({
            token: data.access_token,
            refreshToken: data.refresh_token,
          });
          
          return true;
        } catch (error) {
          console.error('Refresh token error:', error);
          get().logout();
          return false;
        }
      },
      
      setTenantId: (tenantId) => {
        set({ tenantId });
      },
    }),
    {
      name: 'haklai-checkpoint-auth-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
